<template>
<div class="main">
  <section class="sign">
    <div class="hero-body">
      <div class="container">
        <div class="sign-box"
          v-if="$firebase.isAuthorizedGapi">
          <p>読み込み中</p>
        </div>
        <div class="sign-box"
          v-else>
          <h3 class="title">3kyakuに{{ action }}</h3>
          <p>3kyakuはGoogleアカウントを使ってご利用いただけます。機能の一部としてGoogleスプレッドシートを使用するため、「{{ action }}ボタン」を押すと以下のスコープ(権限)が求められます。</p>
          <ul>
            <li>Googleドライブ ファイルの表示と管理</li>
            <li>3kyakuで開いたり作成したりした、Googleドライブのファイルやフォルダの表示と管理</li>
          </ul>
          <div class="sign-button">
            <google-signin-button v-bind:buttonActionLabel="action"></google-signin-button>
          </div>
        </div>
      </div>
    </div>
  </section>
</div>
</template>
<script>
import googleSigninButton from '@/components/parts/googleSigninButton'
export default {
  components: {
    'google-signin-button': googleSigninButton
  },
  data() {
    return {}
  },
  props: ['loginOrSignin'],
  computed: {
    action: function () {
      const actionList = {
        signin: '登録',
        login: 'ログイン'
      }
      return actionList[this.loginOrSignin]
    }
  },
  mounted: function () {},
  methods: {
    signIn: async function () {
      const app = this
      this.$firebase.signInGapi()
    }
  }
}
</script>
